import { Button } from "~/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "~/components/ui/card";

/**
 * Shown when /admin/me fails for a reason that is neither "signed out" nor
 * "not staff" -- a 5xx, or the API being unreachable.
 *
 * This deliberately does not bounce to sign-in. The user *is* signed in, so
 * Clerk would send them straight back here and the two would ping-pong. A dead
 * API is not an authentication problem and must not be presented as one.
 */
export function LoadFailed({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="grid min-h-screen place-items-center bg-background p-6">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Can't reach the API</CardTitle>
          <CardDescription>
            Signing in worked, but loading your staff profile didn't:{" "}
            <span className="text-foreground">{message}</span>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={onRetry}>Try again</Button>
        </CardContent>
      </Card>
    </div>
  );
}
